import { Dialog } from "@headlessui/react";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Groups } from "../../model/Groups";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { GroupUserListSearch } from "./GroupUserListSearch";
import { UserData } from "../../model/Users";
import { useForm } from "react-hook-form";
import { SearchKeys } from "../../model/SearchKeys";
import { Company } from "../../model/Companies";
import { Spiner } from "../../components/spinner/Spiner";

export type GroupUserEditProps = {
  group?: Groups;
  cols: GridCol[];
  rows: GridRow[];
  userList: UserData[];
  groupList: Groups[];
  setSearchUserList: Function;
  setSearchUserListFlg: Function;
  filteredActiveUsers: string[]
  searchKey1List: { value: string; disabled: boolean; }[];
  searchKey2List: { value: string; disabled: boolean; }[];
  searchKey3List: { value: string; disabled: boolean; }[];
  searchKeyList: SearchKeys[] | undefined;
  onClickSubmit: (data: Groups) => Promise<void>;
  companyData?: Company;
  firstPageFlg?: boolean;
  setFirstPageFlg?: Function;
  setIsUpdateSearchKeys: React.Dispatch<React.SetStateAction<boolean>>;
  onSearch: (searchCondition: any) => void;
  searchCondition: any;
  pagingFunc?: (ver: number) => void;
  totalCount?: number;
  isLode?: boolean;
  isUpdateLode?: boolean;
}

export const GroupUserEditModal = ({
  open,
  toggle,
  closeOnClickOutside,
  group,
  cols,
  rows,
  userList,
  groupList,
  setSearchUserList, 
  setSearchUserListFlg, 
  filteredActiveUsers,
  searchKey1List,
  searchKey2List,
  searchKey3List,
  searchKeyList,
  onClickSubmit,
  companyData,
  firstPageFlg = false,
  setFirstPageFlg,
  setIsUpdateSearchKeys,
  onSearch,
  searchCondition,
  pagingFunc,
  totalCount,
  isLode = false,
  isUpdateLode = false,
}: ModalProp & GroupUserEditProps) => {

  const { handleSubmit } =
    useForm<Groups>({
      defaultValues: group,
    });

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-[calc(100vw_-_10rem)]">
          {/* 背景グレーアウト＋ローディング表示 */}
          {isUpdateLode && (
            <div className="absolute inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
              <Spiner />
            </div>
          )}

          <div className="px-2 pb-4 sm:p-4">
            <div className="sm:mt-3">
              <Dialog.Title
                as="h3"
                className="text-left text-lg font-medium leading-6 text-gray-900"
              >
                {`グループユーザ編集：${group?.name}`}
              </Dialog.Title>
              <div className="overflow-y-auto px-8 text-left pb-8 h-fit max-h-[calc(100vh_-_10rem)]">
                <div className="min-w-fit">
                  <div className={"pt-6 pb-3"}>
                    <GroupUserListSearch
                      userList={userList}
                      setSearchUserList={setSearchUserList}
                      setSearchUserListFlg={setSearchUserListFlg}
                      filteredActiveUsers={filteredActiveUsers}
                      groupList={groupList}
                      searchKey1List={searchKey1List}
                      searchKey2List={searchKey2List}
                      searchKey3List={searchKey3List}
                      companyData={companyData}
                      setIsUpdateSearchKeys={setIsUpdateSearchKeys}
                      onSearch={onSearch}
                      searchCondition={searchCondition}
                    />
                  </div>
                  <div>
                    {isLode ? (
                      <Spiner />
                    ) : (
                      <TableList 
                        header 
                        gridCol={cols} 
                        gridRow={rows}
                        firstPageFlg={firstPageFlg}
                        setFirstPageFlg={setFirstPageFlg}
                        pagingFunc={pagingFunc}
                        gridRowLength={totalCount}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 w-[132px]"
              onClick={handleSubmit(onClickSubmit)}
              children={"登録"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  );
};